<template>
  <!-- 创建编辑用户信息弹窗 -->
  <el-dialog
    :visible.sync="modelValue"
    width="400px"
    center
    custom-class="manage-edit-user"
  >
    <div class="edit-id">
      <span>编号:</span>
      <span>{{ editUserNumber }}</span>
    </div>
    <div class="edit-name">
      <span>昵称:</span>
      <el-input v-model="nickName" type="text"></el-input>
    </div>
    <div class="show-tip" v-if="isCreated">
      <span>已存在该昵称</span>
    </div>
    <div class="edit-roles">
      <span class="title">角色:</span>
      <el-select
        v-model="rolesTag"
        multiple
        class="create-input__content font-labelheavy"
        popper-class="create-select"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="edit-name">
      <span>密码:</span>
      <el-input
        v-model="password"
        type="text"
        @change="blurPassword"
        :placeholder="placeholder"
        @focus="placeholder = '请输入新密码'"
      ></el-input>
    </div>
    <div class="show-tip" v-if="passwordTip">
      <span>密码长度应为6-16，且仅支持输入字母或数字</span>
    </div>
    <div class="edit-btn">
      <el-button
        class="confirm-btn"
        @click="handleConfirmEdit()"
        :class="nickName && rolesTag[0] ? 'is-active' : ''"
        >确定</el-button
      >
      <el-button class="cancel-btn" type="primary" @click="handleCancelEdit"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { modelMixin } from '../../assets/js/mixins/model';
import { ROLE_TYPE } from '../../config/constant';
import { updateUser } from '../../api/index';
import { regEpxUserPassword, regEpxDeleteSpace } from '../../config/regEpx';
export default {
  name: 'ManageCreateUser',
  props: {
    editUserPassword: {
      type: String,
      default: ''
    },
    editUserNickName: {
      type: String,
      default: ''
    },
    editUserRoleList: {
      type: Array,
      default: () => []
    },
    editUserUid: {
      type: Number
    },
    editUserNumber: {
      type: Number
    },
    roleList: {
      type: Array,
      required: true
    }
  },
  mixins: [modelMixin],
  data() {
    return {
      isCreated: false,
      options: [
        {
          label: this.roleList[1].roleName,
          value: this.roleList[1].uid
        },
        {
          label: this.roleList[2].roleName,
          value: this.roleList[2].uid
        },
        {
          label: this.roleList[3].roleName,
          value: this.roleList[3].uid
        }
      ],
      rolesTag: [],
      nickName: '',
      password: '',
      passwordTip: false,
      placeholder: '******'
    };
  },
  watch: {
    editUserNickName() {
      this.nickName = this.editUserNickName;
    },
    editUserRoleList() {
      this.rolesTag = this.editUserRoleList;
    }
  },
  updated() {},
  methods: {
    /**
     * 确认修改
     * @param {Array} updateUserRoleUidList 角色信息
     */
    handleConfirmEdit(
      nickName,
      password,
      updateUserRoleUidList,
      userUid = this.editUserUid
    ) {
      if (this.nickName && this.rolesTag[0] && !this.passwordTip) {
        if (this.password) {
          updateUser({
            nickName: this.nickName,
            password: this.password,
            updateUserRoleUidList: this.rolesTag,
            userUid
          }).then(res => {
            if (res.data.code == 200) {
              this.placeholder = '******';
              this.password = '';
              this.rolesTag = [];
              this.$emit('onConfirmEdit');
              this.modelValue = false;
              this.$prompt('修改成功');
              this.isCreated = false;
            } else if (res.data.code == 500) {
              this.isCreated = true;
            }
          });
        } else {
          updateUser({
            nickName: this.nickName,
            updateUserRoleUidList: this.rolesTag,
            userUid
          }).then(res => {
            if (res.data.code == 200) {
              this.placeholder = '******';
              this.password = '';
              this.rolesTag = [];
              this.$emit('onConfirmEdit');
              this.modelValue = false;
              this.$prompt('修改成功');
            }
          });
        }
      }
    },

    /**
     * 取消编辑
     */
    handleCancelEdit() {
      this.placeholder = '******';
      this.password = '';
      this.rolesTag = [];
      this.$emit('onCancelEdit');
      this.modelValue = false;
      this.$prompt('取消编辑');
    },
    /**
     * 失去焦点
     */
    blurPassword() {
      this.password = regEpxDeleteSpace(this.password);
      if (!this.password) {
        this.password = '******';
      } else {
        this.passwordTip = regEpxUserPassword(this.password);
      }
    }
  }
};
</script>

<style lang="scss">
.manage-edit-user {
  .el-dialog {
    &__header {
      padding: 0;
    }
    &__body {
      padding: 0 40px;
      padding-top: 40px;
      padding-bottom: 20px;
      overflow-y: auto;
    }
    &__headerbtn {
      display: flex;
      font-size: 30px;
      color: #fff;
      top: -5px;
      right: -40px;
    }
    &__close {
      color: #fff;
    }
  }
  .edit-id {
    span {
      margin-right: 40px !important;
    }
  }
  .edit-name {
    display: flex;
    justify-content: space-between;
    margin: 15px 0;
    span {
      margin-right: 15px;
      line-height: 30px;
    }
    .el-input {
      width: 250px;
      height: 30px;
      .el-input__suffix-inner {
        .el-input__icon {
          line-height: 30px;
        }
      }
      &__inner {
        width: 250px;
        height: 30px;
        border-radius: 0;
        padding-left: 5px;
        &:focus {
          border-color: $color-border-light;
        }
      }
    }
  }
  .edit-roles {
    display: flex;
    justify-content: space-between;
    .title {
      line-height: 30px;
    }
    .create-select {
      .el-select-dropdown {
        &__item {
          height: 20px;
          line-height: 20px;
          font-size: 13px;
          font-family: 'Arial Negreta';
        }
      }
    }
    .create-input__content {
      margin-left: 34px;
      width: 250px;
      .el-input,
      .el-textarea {
        &__inner {
          padding: 0 3px;
          height: 30px;
          font-size: 13px;
          line-height: 30px;
          resize: none;
          border-radius: unset;
          border: 1px solid $color-border-light !important;
          box-shadow: 0;
        }
        &__suffix {
          &-inner {
            display: flex;
            align-items: center;
            height: 100%;
          }
        }
      }
      .el-textarea__inner {
        line-height: 18px;
      }
      .el-select {
        &__caret {
          color: #000 !important;
          font-weight: bold;
          font-size: 12px !important;
          line-height: 1;
        }
      }
    }
  }
  .show-tip {
    position: absolute;
    color: red;
    font-size: 11px;
    margin-left: 70px;
    margin-top: -15px;
    z-index: 200;
  }
  .edit-btn {
    display: flex;
    justify-content: center;
    margin-top: 35px;
    .el-button {
      border: 0;
    }
    .confirm-btn {
      margin-right: 20px;
      background-color: $color-disabled;
      font-size: 13px;
      color: #fff;
    }
    .is-active {
      background-color: $color-primary;
    }
  }
}
</style>
